import axios from 'axios';
import { Api, createUri } from './utils';

import type { SystemStatus } from '@consts/systems';

const DATA_URL = createUri(Api.Systems, '/system/V1');

export enum SystemUrl {
    Counts = 'counts',
    Station = 'station',
    StationsByLocation = 'locationStations',
    Stations = 'stations',
    Config = 'config',
}

/**
 * LocationID, System Count
 */
export type SystemCounts = Record<string, number>;

export type System = {
    StationID: number | null;
    LocationID: number | null;
    CompanyID: number | null;
    ResellerID: number | null;
    Model: number | null;
    Hostname: string;
    CreatedDate: string;
    SerialNum: string | null;
    Status: SystemStatus | null;
    LastConnected: string | null;
    ConfigHash: string | null;
    ProductID: string | null;
    Notes: string | null;
};

export type SystemData = {
    totalStationsInQuery: string;
    stationId: number | null;
    locationId: number | null;
    companyId: number | null;
    resellerCompanyId: number | null;
    model: number | null;
    hostname: string;
    createdDate: string;
    serialNum: null | string;
    status: SystemStatus;
};

export const systemApi = axios.create({
    baseURL: DATA_URL,
});

export type SystemPayload = {
    stationId: number;
    locationId: number | null;
    resellerCompanyId: number | null;
    companyId: number | null;
    status: string;
};

export const fetchSystemData = async <T>(token: string, url: SystemUrl, params?: Record<string, string | number>) => {
    const resp = await systemApi.get<T>(url, {
        params,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return resp.data;
};

export const fetchSystemCSV = async (token: string, params?: Record<string, string | number>) => {
    const resp = await systemApi.get('systemsCSV', {
        params,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return resp.data;
};
